import {createApp} from '../../../../../vendor/vue/dist/vue.esm-browser.js';
import {get} from "./data-manager";
import Animate from "./animate";

export default class Search {
    constructor($el) {
        this.$wrapper = $el;

        this.createVueApp = this.createVueApp.bind(this);
        this.createVueApp();
    }

    createVueApp() {
        const container = this.$wrapper;
        const app = createApp({
            data() {
                return {
                    searchText: '',
                    categories: [],
                    products: [],
                    totalCategories: 0,
                    totalProducts: 0,
                    showResults: false,
                    showSearchStatus: false,
                    hasSearched: false,
                    searching: false,
                    timer: null,
                    searchUrl: null,
                }
            },
            computed: {
                searchResultUrl() {
                    const url = new URL(this.searchUrl);
                    url.searchParams.append('q', this.searchText);

                    return url.toString()
                }
            },
            methods: {
                updateMobileResultsPosition() {
                    if (!window.matchMedia('(max-width: 991.98px)').matches) {
                        container.style.removeProperty('--mobile-search-results-top');
                        return;
                    }

                    const input = container.querySelector('[data-role="search"]');
                    if (input) {
                        container.style.setProperty(
                            '--mobile-search-results-top',
                            `${Math.ceil(input.getBoundingClientRect().bottom + 8)}px`
                        );
                    }
                },
                highlightSearch(search) {
                    var exp = `(${this.searchText})`
                    var reg = new RegExp(exp, "gi")
                    return search.replaceAll(reg, "<strong>$1</strong>");
                },
                async search() {
                    this.updateMobileResultsPosition();
                    clearTimeout(this.timer);

                    if (this.abortController) {
                        this.abortController.abort();
                        this.abortController = null;
                    }

                    if (!this.searchText) {
                        this.categories = [];
                        this.products = [];
                        this.totalCategories = 0;
                        this.totalProducts = 0;
                        this.showResults = false;
                        this.showSearchStatus = false;
                        this.hasSearched = false;
                        this.searching = false;
                        return;
                    }

                    const searchText = this.searchText;
                    this.categories = [];
                    this.products = [];
                    this.totalCategories = 0;
                    this.totalProducts = 0;
                    this.showResults = false;
                    this.showSearchStatus = true;
                    this.hasSearched = false;
                    this.searching = true;

                    this.timer = setTimeout(async () => {
                        const url = `${baseHref}ajax/search`;
                        const abortController = new AbortController();
                        this.abortController = abortController;

                        const result = await get(url, {
                            'q': searchText,
                            'page': this.page
                        }, abortController.signal);

                        if (this.abortController !== abortController || this.searchText !== searchText) {
                            return;
                        }

                        this.abortController = null;
                        this.searching = false;

                        if (result && Array.isArray(result.tabs)) {
                            const categoryResults = result.tabs.find(tab => tab.slug === 'categorie') || {data: [], count: 0};
                            const productResults = result.tabs.find(tab => tab.slug === 'product') || {data: [], count: 0};

                            this.categories = categoryResults.data;
                            this.products = productResults.data;
                            this.totalCategories = categoryResults.count;
                            this.totalProducts = productResults.count;
                            this.hasSearched = true;
                            this.showResults = (this.categories.length > 0 || this.products.length > 0)
                                && this.showSearchStatus
                                && container.contains(document.activeElement);
                        }
                    }, 500);
                },
                clearSearch() {
                    clearTimeout(this.timer);
                    if (this.abortController) {
                        this.abortController.abort();
                        this.abortController = null;
                    }

                    this.categories = [];
                    this.products = [];
                    this.totalCategories = 0;
                    this.totalProducts = 0;
                    this.searchText = '';
                    this.showResults = false;
                    this.showSearchStatus = false;
                    this.hasSearched = false;
                    this.searching = false;
                }
            },
            async mounted() {
                document.body.addEventListener('click', (e) => {
                    if (!container.contains(e.target)) {
                        this.showResults = false;
                        this.showSearchStatus = false;
                    }
                });

                this.searchUrl = container.querySelector('[data-search-url]').dataset.searchUrl;
                window.addEventListener('resize', this.updateMobileResultsPosition);
                window.addEventListener('scroll', this.updateMobileResultsPosition, {passive: true});
                this.updateMobileResultsPosition();

                await this.search();
            },
        });

        app.config.compilerOptions.delimiters = ['v{', '}'];

        // mount the app
        app.mount(this.$wrapper);
    }
}
